import { Directive, TemplateRef } from '@angular/core';

@Directive({ selector: '[grid-body-list-row-template]' })
export class GridBodyListRowTemplateDirective {
  constructor(public template: TemplateRef<any>) {}
}
